/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["article-host{display:block;height:100%}article-host>.scroll-container{height:100%}article-host hc-compact-header{border-bottom:1px solid #e0e0e0}article-host hc-compact-header>.page-header{background-color:#fcfcfc}@media only screen and (max-width:1200px){article-host .content{display:block;padding-top:20px}article-host .content .article-body{min-width:initial}article-host .content .related-content{margin-bottom:35px}}"];
export { styles as styles };
